'use strict'  
window.onload = () => {

  
const returnurl = queryname => {
  let url = window.location.href
  let query = url.indexOf(queryname)
  let string = query > 0 ? url.substr(query + queryname.length + 1) : ''  
  let nr = string.substring(0, string.indexOf('&') > 0 ? string.indexOf('&') : string.length)
  return nr
}


let rewardnr = returnurl('rewardno')  
   
parseFloat(rewardnr) > 1 ? document.getElementById('norwegian-reward-nr').value = rewardnr : null


document.getElementById('cartform').addEventListener('submit', e => {
  document.getElementById('norwegian-error-message').style.display = 'none'
  let n = document.getElementById('norwegian-reward-nr').value
  if((n != '' || n != null) && !isValidRewardNumber(n)) {
    e.preventDefault()
    document.getElementById('norwegian-error-message').style.display = 'block'
    console.log('preventDefault')
  } else {
    return true
  }
})
  
function isValidRewardNumber(rewardNumber) {
  /*
    var isDigitRegExp = new RegExp("^\\d{8}(\\d{2})?$");
    if (isDigitRegExp.test(rewardNumber)) {
        var len = rewardNumber.length;
        var rewardNumberWithoutCheckDigit = rewardNumber.substring(0, len-1);
        var checkDigit = rewardNumber.substring(len-1, len);
        var calculatedCheckDigit = calculateRewardNumberCheckDigit(rewardNumberWithoutCheckDigit);
        return checkDigit === calculatedCheckDigit;
    }
    return false;
    */ return true
}

function calculateRewardNumberCheckDigit(val) {
    var checksum = new Array();
    var odd = false;
    var increment = 0;
    var i;
    for(i = 0; i < val.length; i++) {
        var t = val.substring(i, i + 1);
        if (odd) {
            odd = false;
            var intCheck = parseInt(t);
            var oddCheck = (intCheck * 2).toString();
            for (var j = 0; j < oddCheck.length; j++) {
                checksum[increment++] = oddCheck.substring(j, j + 1);
            }
        }
        else {
            odd = true;
            checksum[increment++] = t;
        }
    }
    var sumInput = 0;
    var sumChecksum = 0;
    for (i = 0; i < val.length; i++) {
        var t2 = val.substring(i, i + 1);
        var currentInt = parseInt(t2);
        sumInput = sumInput + currentInt;
    }
    for (i = 0; i < checksum.length; i++) {
        if (parseInt(checksum[i])) 
        {
            sumChecksum = sumChecksum + parseInt(checksum[i]);
        }
    }
    var topRes = sumChecksum + 10;
    var divRes = Math.floor(topRes / 10);
    var sumRes = divRes * 10;
    var calcCheckSum = sumRes - sumChecksum;
    // if the highest number 10 is 10 then we force it to 0 to avoid number
    // overflow
    if (calcCheckSum == 10) {
        calcCheckSum = 0;
    }
    return calcCheckSum.toString();
}
  
}